import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";

export const itemVariants = cva("flex items-center gap-2 rounded-[10px] transition-colors", {
  variants: {
    variant: {
      default: "border-none bg-transparent",
      outline: "border border-border",
      muted: "border-none bg-muted",
      destructive: "border-none bg-destructive/10",
    },
    size: {
      default: "py-2.5 px-3",
      sm: "py-2 px-2.5",
      lg: "py-3 px-3.5",
    },
    clickable: {
      true: "cursor-pointer hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      false: "",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
    clickable: false,
  },
});

export const itemMediaVariants = cva("flex items-center [&>svg]:h-4 [&>svg]:w-4", {
  variants: {
    variant: {
      default: "",
      icon: "text-muted-foreground",
      "icon-destructive": "text-destructive",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

// TypeScript interfaces
export interface ItemProps extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof itemVariants> {
  asChild?: boolean;
  clickable?: boolean;
}

export interface ItemMediaProps extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof itemMediaVariants> {}

export interface ItemTitleProps extends HTMLAttributes<HTMLHeadingElement> {
  variant?: "default" | "destructive";
}

export interface ItemDescriptionProps extends HTMLAttributes<HTMLParagraphElement> {
  variant?: "default" | "destructive";
}
